import React, { useState } from 'react'

import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
  Stack,
  TextField,
} from '@mui/material'
import { listFromCodes } from '../../Functions/ListItemGenerator'
import { useGlobalContext } from '../../Contexts/GlobalTriggers'

import { useUserContext } from '../../Contexts/UserConfig'
import { useHoldingContext } from '../../Contexts/CurrentHolding'
import PageSection from '../../Constants&Theme/PageSection'
import { useVesselOpen } from '../../APIs/Hooks/VesselHooks'

function VesselViewSelect() {
  const { playScanSound } = useGlobalContext()
  const { loginConfig, loadingConfig } = useUserContext()
  const { currentHolding } = useHoldingContext()
  const [vesselID, setVesselID] = useState<string | undefined>(undefined)
  const [holding, setHolding] = useState<number | undefined>(
    currentHolding.value,
  )
  const { mutate: openVessel } = useVesselOpen(holding, vesselID)

  const holdings = listFromCodes(
    loginConfig,
    'KV-Holdings',
    loadingConfig,
    currentHolding.value,
  )

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: 1,
        maxWidth: 400,
      }}
    >
      <Stack
        gap={5}
        width={1}
      >
        <PageSection title={'View Vessel'}>
          <Stack width={1}>
            <FormControl fullWidth>
              <TextField
                autoFocus
                label="Vessel ID"
                value={vesselID || ''}
                onChange={(e) => {
                  setVesselID(e.target.value)
                  playScanSound(true)
                }}
              />
              <FormHelperText>Scan or enter the Vessel ID</FormHelperText>
            </FormControl>
            <Button
              disabled={!vesselID}
              variant="contained"
              onClick={() => openVessel('vessel')}
            >
              View Vessel
            </Button>
          </Stack>
        </PageSection>
        <PageSection title={'View Holding Vessels'}>
          <Stack width={1}>
            <FormControl
              margin="normal"
              fullWidth
            >
              <InputLabel>Select Vessel Location</InputLabel>
              <Select
                label="Select Vessel Location"
                name="holding"
                value={holding || ''}
                onChange={(e) => setHolding(e.target.value as number)}
              >
                {holdings}
              </Select>
            </FormControl>
            <Button
              variant="contained"
              onClick={() => openVessel('holding')}
            >
              View Vessels
            </Button>
          </Stack>
        </PageSection>
      </Stack>
    </Box>
  )
}

export default VesselViewSelect
